import dispatcher from '../dispatcher';
import scrollStore from '../scroll/scroll.store';
import resizeStore from '../resize/resize.store';
import * as utils from '../utils';

var elements;

var _handleScroll = function() {
	var wh = resizeStore.getData().height;
	var scrolled = scrollStore.getData().top;

	var checkElement = function(element) {
		var from = element._parallaxFrom;
		var to = element._parallaxTo;

		var tp = element._parallaxOffsetTop - wh;
		var bt = element._parallaxOffsetTop + element._parallaxHeight;

		var c = (from - to) / (bt - tp);
		var p = c * (element._parallaxOffsetTop - scrolled) + from - (from - to) / 2;

		if (scrolled > tp && scrolled < bt) {
			element.style.transform = 'translateY(' + p + 'px)';
		}
	}

	Array.prototype.forEach.call(elements, function(element) {
		checkElement(element, false);
	});
}

var _handleResize = function() {
	Array.prototype.forEach.call(elements, function(element) {
		element._parallaxOffsetTop = utils.offset(element).top;
		element._parallaxHeight = element.clientHeight;
	});
}

var _getElements = function() {
	elements = document.getElementsByClassName('simple-parallax');

	Array.prototype.forEach.call(elements, function(element) {
		element._parallaxFrom = element.getAttribute('data-parallax-from') || 100;
		element._parallaxTo = element.getAttribute('data-parallax-to') || -100;

		element._parallaxFrom = parseInt(element._parallaxFrom);
		element._parallaxTo = parseInt(element._parallaxTo);
	});
}

var _handleDispatcher = function(e) {
	if (e.type === 'content:replaced') {
		_getElements();
		_handleResize();
		_handleScroll();
	}
}

var init = function() {
	_getElements();
	_handleResize();
	_handleScroll();
	resizeStore.subscribe(_handleResize);
	resizeStore.subscribe(_handleScroll);
	scrollStore.subscribe(_handleScroll);
	dispatcher.subscribe(_handleDispatcher);
}

export default {
	init: init
};